const BASE_URL = "https://staging.mobikasa.com"

const CONFIG = {
  "getQuote": `${BASE_URL}/landingpage/landingpage/lead_submit.php`,
  "career": `${BASE_URL}/landingpage/landingpage/mobikasa_careers.php`,
  "recaptchaSiteKey": "6Ld9xu4UAAAAACOpnykEWsyqrioQ24zmK4XKl8LY"
}

export default CONFIG;